module.exports = __webpack_public_path__ + "686397822063cb9358f7decda9853d51.png";